import type React from 'react';
import Button from '../atoms/Button';
import Input from '../atoms/Input';

export interface SessionEditFormProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  placeholder?: string;
}

export default function SessionEditForm({
  value,
  onChange,
  onSave,
  onCancel,
  placeholder = 'Enter session title...',
  className = '',
  ...props
}: SessionEditFormProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSave();
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  };

  return (
    <div className={`space-y-3 ${className}`} {...props}>
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        size="sm"
        autoFocus
        onKeyDown={handleKeyDown}
      />
      <div className="flex space-x-2">
        <Button
          onClick={onSave}
          variant="primary"
          size="small"
          className="flex-1 bg-success hover:bg-success-border"
        >
          Save
        </Button>
        <Button
          onClick={onCancel}
          variant="neutral"
          size="small"
          className="flex-1"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}